import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';

/** WCAG 2.4.1 skip link. Must be the first focusable element on the page. */
const SkipToMain = () => {
  const { t } = useTranslation();

  return (
    <Link
      href="#main-content"
      sx={{
        position: 'absolute',
        top: -9999,
        left: -9999,
        bgcolor: 'background.paper',
        color: 'text.primary',
        px: 2,
        py: 1,
        borderRadius: 1,
        fontWeight: 600,
        textDecoration: 'none',
        zIndex: (theme) => theme.zIndex.modal + 1,
        '&:focus, &:focus-visible': {
          top: 8,
          left: 8,
          outline: (theme) => `2px solid ${theme.palette.primary.main}`,
          boxShadow: 3,
        },
      }}
    >
      {t('finder.skip_to_main')}
    </Link>
  );
};

export default SkipToMain;
